export default __webpack_public_path__ + "static/tech-stack@2x-3596f344c7112337d0d91195160ecc5f.png";